import React, { useMemo } from "react";
import { ResourceFeature, ResourceFunction, Resources, RoleResource } from "Models/resources";
import useStyles from "./style";
import Checkbox from "Components/Form/Checkbox";
import { RoleType } from "Util/enums";
import { Roles } from "Models/user";

interface AccessRuleFeatureFunctionCardCheckboxProps {
  accessRule?: Roles;
  feature: ResourceFeature;
  resource: Resources;
  roleResources: RoleResource[];
  functionObj: ResourceFunction;
  masterDataPermissions: ResourceFunction[];
  handleChangePermissionCheckBoxForMasterData: (functionObj: ResourceFunction) => void;
  handleSetPermissionCheckBox: (functionObj: ResourceFunction) => boolean;
  handleChangePermissionCheckBox: (functionObj: ResourceFunction, resource: Resources) => void;
}

export const AccessRuleFeatureFunctionCardCheckbox = (
  props: AccessRuleFeatureFunctionCardCheckboxProps
) => {
  const {
    functionObj,
    accessRule,
    roleResources,
    resource,
    feature,
    masterDataPermissions,
    handleChangePermissionCheckBoxForMasterData,
    handleChangePermissionCheckBox,
    handleSetPermissionCheckBox,
  } = props;
  const classes = useStyles();

  const isMasterPermissionCheckboxSelected = useMemo(() => {
    return masterDataPermissions?.some(
      (obj) => obj?.id === functionObj?.id && obj?.resourceId === functionObj?.resourceId
    );
  }, [masterDataPermissions, functionObj]);

  const isSystemRuleType = useMemo(() => {
    return accessRule?.type === RoleType.SYSTEM
  }, [accessRule?.type]);

  const roleResourceActive = useMemo(() => {
    return roleResources.find((roleResource) => roleResource.id === resource?.id)
  }, [roleResources, resource])

  const isViewAllowedByResources = useMemo(() => {
    return !!roleResourceActive?.view
  }, [roleResourceActive]);

  const isEditAllowedByResources = useMemo(() => {
    return !!roleResourceActive?.edit
  }, [roleResourceActive]);

  const isViewAllowedByRoleResources = useMemo(() => {
    return functionObj?.name?.toLowerCase()?.includes("view") || feature?.name?.toLowerCase()?.includes("view") || isEditAllowedByResources;
  }, [functionObj?.name, feature?.name, isEditAllowedByResources]);

  const isDisabledWhenDoesntFoundResource = useMemo(() => {
    return ((functionObj?.name?.toLowerCase()?.includes("view") ||
            feature?.name?.toLowerCase()?.includes("view")) &&
            !isViewAllowedByResources);
  }, [functionObj?.name, feature?.name, isViewAllowedByResources])

  if (functionObj?.name === "Confirmation of accessorial services provided") {
    console.log(functionObj)
  }

  if (functionObj?.objectData) {
    return (
      <div style={{ margin: "8px" }}>
        <Checkbox
          className={classes.accordionPermissionCheckbox}
          disabled={
            isSystemRuleType || !isViewAllowedByResources
          }
          control={{
            "data-cy": functionObj?.name,
          }}
          label={functionObj?.name}
          checked={isMasterPermissionCheckboxSelected}
          onChange={() => handleChangePermissionCheckBoxForMasterData(functionObj)}
        />
      </div>
    );
  }

  return (
    <div style={{ margin: "8px" }}>
      <Checkbox
        className={classes.accordionPermissionCheckbox}
        disabled={
          isSystemRuleType || !isViewAllowedByRoleResources || isDisabledWhenDoesntFoundResource
        }
        control={{
          "data-cy": functionObj?.name,
        }}
        label={functionObj?.name}
        checked={handleSetPermissionCheckBox(functionObj)}
        onChange={() => handleChangePermissionCheckBox(functionObj, resource)}
      />
    </div>
  );
};
